import { Tag, Modal, Avatar, Space, Dropdown } from "antd";
import { DownOutlined, UserOutlined } from "@ant-design/icons";

import IntlHOC from "components/util-components/IntlMessage/intl_hoc";

import useNavSignout from "hooks/Layout/NavSignout";

const NavSignout = (props) => {
  const { intl } = props;
  const {
    profile,
    closing,
    userMenu,
    willSignout,
    dropDownRef,
    handleSignout,
    handleCancelSignout,
  } = useNavSignout({ intl });

  return (
    <>
      <Modal
        title="Gocsa"
        onOk={handleSignout}
        visible={willSignout}
        confirmLoading={closing}
        onCancel={handleCancelSignout}
      >
        {intl.formatMessage({ id: "auth.confirm_sign_out" })}
      </Modal>
      <div ref={dropDownRef} className="ml-3">
        <Dropdown overlay={userMenu}>
          <div onClick={(e) => e.preventDefault()} style={{ cursor: 'pointer' }}>
            <Space>
              <Avatar
                size={36}
                icon={<UserOutlined />}
                className="d-none d-sm-block"
              />
              <span className="d-block">
                {profile.firstname} {profile.lastname}
              </span>
              {profile.client ? (
                <Tag color="blue">Cliente {profile.client.name}</Tag>
              ) : (
                <Tag color="green">Empresa {profile.company.name}</Tag>
              )}
            </Space>
          </div>
        </Dropdown>
      </div>
    </>
  );
};

export default IntlHOC(NavSignout);
